import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
import { makeObservable, observable } from 'mobx';

export interface IBookingCutoffRouteAttributes extends IModelAttributes {
	bookingCutoffId: string;
	routeId: string;

	bookingCutoff: Models.BookingCutoffEntity | Models.IBookingCutoffEntityAttributes;
	route: Models.RouteEntity | Models.IRouteEntityAttributes;
}

@entity('BookingCutoffRoute')
export default class BookingCutoffRoute extends Model implements IBookingCutoffRouteAttributes {
	@observable
	@attribute()
	public bookingCutoffId: string;

	@observable
	@attribute()
	public routeId: string;

	@observable
	@attribute({ isReference: true })
	public bookingCutoff: Models.BookingCutoffEntity;

	@observable
	@attribute({ isReference: true })
	public route: Models.RouteEntity;

	constructor(attributes?: Partial<IBookingCutoffRouteAttributes>) {
		super(attributes);

		makeObservable(this);

		if (attributes) {
			if (attributes.bookingCutoffId) {
				this.bookingCutoffId = attributes.bookingCutoffId;
			}
			if (attributes.routeId) {
				this.routeId = attributes.routeId;
			}

			if (attributes.bookingCutoff) {
				if (attributes.bookingCutoff instanceof Models.BookingCutoffEntity) {
					this.bookingCutoff = attributes.bookingCutoff;
					this.bookingCutoffId = attributes.bookingCutoff.id;
				} else {
					this.bookingCutoff = new Models.BookingCutoffEntity(attributes.bookingCutoff);
					this.bookingCutoffId = this.bookingCutoff.id;
				}
			} else if (attributes.bookingCutoffId !== undefined) {
				this.bookingCutoffId = attributes.bookingCutoffId;
			}

			if (attributes.route) {
				if (attributes.route instanceof Models.RouteEntity) {
					this.route = attributes.route;
					this.routeId = attributes.route.id;
				} else {
					this.route = new Models.RouteEntity(attributes.route);
					this.routeId = this.route.id;
				}
			} else if (attributes.routeId !== undefined) {
				this.routeId = attributes.routeId;
			}
		}
	}
}
